<template>
  <div class="container-rules" :style="cssVars()">
    <div class="page-bg"></div>
    <div class="custom-nav-block" :style="`paddingTop:${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <!-- Rules -->
          <span class="tit-left">{{ $t('lang.BaseModule.k075') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <!-- 标题和警告 -->
      <div class="text1">{{ $t('lang.BaseRules.k036') }}</div>
      <!-- call规则 -->
      <div class="title">{{ $t('lang.BaseRules.k035') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k022') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k027') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k028') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k029') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k030') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k031') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k032') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k033') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k034') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k023') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k024') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k025') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k026') }}</div>
      <br />
      <!-- chat规则 -->
      <div class="title">{{ $t('lang.BaseRules.k037') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k044') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k038') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k039') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k040') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k041') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k042') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k043') }}</div>
      <br />
      <!-- 账户规则 -->
      <div class="title">{{ $t('lang.BaseRules.k015') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k001') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k016') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k017') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k018') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k019') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k020') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k021') }}</div>
      <br />
      <!-- 结语 -->
      <div class="text1">{{ $t('lang.BaseRules.k045') }}</div>
    </div>
  </div>
</template>

<script>
import { getBaseFeature } from '@/assets/style/variable'

export default {
  data() {
    return {}
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
  },
}
</script>
<style lang="scss" scoped>
.container-rules {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f5efe5;

  .page-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 775px;
    background: url('~@/assets/packageAssets/views/P2_Page/Invite/default/rules-bg.webp') top center / 100% auto no-repeat;
    pointer-events: none;
  }

  .custom-nav-block {
    position: relative;
    z-index: 2;
    background: transparent;
  }

  .main {
    position: relative;
    z-index: 1;
    flex: 1;
    width: 100%;
    overflow-y: scroll;

    .title {
      padding: 8px 16px;
      margin: 0;
      font-family: var(--string-font);
      font-weight: var(--fw-600);
      font-size: var(--fs-14);
      line-height: var(--lh-body-20);
      color: #333333;
    }

    .text1 {
      width: 100%;
      padding: 4px 16px;
      margin: 0;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-14);
      line-height: var(--lh-body-20);
      color: #666666;
    }
  }
}
</style>
<style lang="scss">
.container-rules {
  .van-nav-bar {
    background: transparent;
  }
}
</style>
